export interface TiminatorTypes extends TiminatorTypesBase {
    items: TiminatorType[],
}

export interface TiminatorAbsenceTypes extends TiminatorTypesBase {
    items: TiminatorAbsenceType[],
}

export interface TiminatorTagTypes extends TiminatorTypesBase {
    items: TiminatorTagType[],
}

interface TiminatorTypesBase {
    offset: number,
    total: number,
    permissions?: string[],
}

export interface TiminatorType {
    id: number,
    name: string,
    active: boolean,
    default: boolean,
}

export interface TiminatorTagType extends TiminatorType {
    id: number,
    name: string,
    active: boolean,
    default: boolean
}

export enum AbsenceBehavior {
    None = 0,
    Vacation = 1,
    WillWork = 2,
    LimitToPlannedHours = 3,
}

export interface TiminatorAbsenceType extends TiminatorType {
    behavior: AbsenceBehavior,
}

export type Types = 'shifts' | 'projects' | 'absences' | 'tags'
